import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { Filter9Plus, Style } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import './GameSelection.scss';
import SubscriptionGate from '../components/SubscriptionGate';
import { useSubscription } from '../context/SubscriptionContext';

const games = [
    { key: 'poker', title: 'gameSelection.poker', description: 'gameSelection.pokerDescription', path: '/poker', icon: <Style /> },
    { key: 'shan9mee', title: 'gameSelection.shan', description: 'gameSelection.shanDescription', path: '/shan9mee', icon: <Filter9Plus /> },
];

export default function GameSelection() {
    const { t } = useTranslation();
    const { feature, ready } = useSubscription();
    if (ready === false) return null;

    const visibleGames = games.filter(game => feature(game.key, 'game').show);
    if (visibleGames.length === 1 && feature(visibleGames[0].key, 'game').allowed) {
        return <Navigate to={visibleGames[0].path} replace />;
    }

    return <main className="app-page game-selection-page">
        <section className="game-selection-content">
            <Typography component="h1" variant="h4">{t('gameSelection.chooseGame')}</Typography>
            <div className="game-selection-grid">
                {games.map(game => <SubscriptionGate key={game.path} game={game.key} feature="game"><Card className="game-choice-card">
                    <CardActionArea component={Link} to={game.path}>
                        {game.icon}
                        <CardContent>
                            <Typography component="h2" variant="h5">{t(game.title)}</Typography>
                            <Typography>{t(game.description)}</Typography>
                        </CardContent>
                    </CardActionArea>
                </Card></SubscriptionGate>)}
            </div>
        </section>
    </main>;
}
